import { render, staticRenderFns } from "./clearAccount.vue?vue&type=template&id=b5b8d59e&scoped=true"
import script from "./clearAccount.vue?vue&type=script&lang=js"
export * from "./clearAccount.vue?vue&type=script&lang=js"
import style0 from "./clearAccount.vue?vue&type=style&index=0&id=b5b8d59e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b8d59e",
  null
  
)

export default component.exports